module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"contactSupport":"Contact Support","FlowSolutions":"Company Info","FAQ":"FAQ","SupportPage":"Support Page"}}')
  delete Component.options._Ctor
}
